import { useState } from 'react';
import { services } from '../data';
import s from './Services.module.css';

export default function Services() {
  const [hovered, setHovered] = useState(null);
  return (
    <section id="services" className="light-section" aria-label="Services">
      <div className="section-inner">
        <div className={s.header}>
          <div>
            <div className="kicker">
              <div className="kicker-line-light" />
              <span className="kicker-text-light">What We Do</span>
            </div>
            <h2 className={`section-h ${s.heading}`}>Services We're<br />Proud to Offer</h2>
          </div>
          <p className={s.sub}>From idea to launch — every layer handled with care.</p>
        </div>
        <div className={s.grid}>
          {services.map((svc, i) => (
            <div
              key={svc.title}
              className={s.card}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              <div className={`${s.iconWrap} ${hovered === i ? s.iconHovered : ''}`}>{svc.icon}</div>
              <h3 className={s.title}>{svc.title}</h3>
              <p className={s.desc}>{svc.desc}</p>
              <div className={s.tag}>{svc.tag}</div>
              <div className={`${s.bar} ${hovered === i ? s.barVisible : ''}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
